import api from './api';
import type { MenuShare } from '../types/menu';

const base = (venueId: string, menuId: string) =>
  `/admin/venue/${venueId}/menu/${menuId}/share`;

const menuShareService = {
  /** Get the active share for a menu, or 404 if none. */
  getShare: async (venueId: string, menuId: string): Promise<MenuShare> => {
    const response = await api.get(base(venueId, menuId));
    return response.data;
  },

  /**
   * Idempotent: returns the existing active share or creates a new one. Slug
   * is auto-derived from the menu name. NOTE: the public /m/:slug route does
   * not yet resolve cocktail menus; the slug is reserved for a future phase.
   */
  createOrGetShare: async (venueId: string, menuId: string): Promise<MenuShare> => {
    const response = await api.post(base(venueId, menuId));
    return response.data;
  },

  /** Soft-revoke by setting isActive=false; the slug is preserved. */
  revokeShare: async (venueId: string, menuId: string): Promise<void> => {
    await api.delete(base(venueId, menuId));
  },
};

export default menuShareService;
